import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { 
Accordion, 
Button, 
Col, 
Container, 
Form, ListGroup, Row, Table } from 'react-bootstrap'

const SECTION_TITLE_1='Contact & Program Identification'
const SECTION_TITLE_2='Focus of Assessment'
const SECTION_TITLE_3='Initial Round of Assessment'
const SECTION_TITLE_4='Analysis of Initial Round of Assessment Data'
const SECTION_TITLE_5='Changes Implemented'
const SECTION_TITLE_6='Second Round of Assessment'
const SECTION_TITLE_7='Analysis of Second Round of Assessment Data'
const SECTION_TITLE_8='Program Summary'

const PHASE_ONE=1
const PHASE_TWO=2
const CURRENT_PHASE=PHASE_ONE

function ChangeList(props) {
    let slo = props.slo
    return (
        <ul>
            {slo.approachToolChanges === true &&
                <li>Change in teaching approach</li>
            }
            {slo.facultyDevelopment === true &&
                <li>Faculty training/development</li>
            }
            {slo.courseContentChanges === true &&
                <li>Change in course content</li>
            }
            {slo.courseSequencePrerequisiteChanges === true &&
                <li>Change in course sequence/prerequisites</li>
            }
            {slo.gradingMethodologyChanges === true &&
                <li>Grading Methodology Changes</li>
            }
            {slo.assignmentRevisionChanges === true &&
                <li>Assignment revision</li>
            }
            {slo.budgetaryReallocationChanges === true &&
                <li>Budgetary reallocation</li>
            }
            {slo.otherChanges === true &&
                <li>Other</li>
            }
        </ul>
    )
}

export default function AssessmentViewPage(props) {
    const {assessmentId} = useParams()
    
    let assessment = {}

    for (const [key,value] of Object.entries(props.programAssessments)) {
        if (value.assessmentId === props.assessmentId) {
            assessment = value
            break
        }
    }

    
    let programId = assessment.programId
    let step1Data = assessment.step1Data
    let step2Data = assessment.step2Data
    let step4Data = assessment.step4Data
    let step5Data = assessment.step5Data
    let step7Data = assessment.step7Data

    let departmentSlos = props.learningOutcomes[assessment.departmentId]
    let learningOutcomes = departmentSlos.learningOutcomes[assessment.programId]
    let learningOutcomesMap = {}
    learningOutcomes.forEach(slo => {
        learningOutcomesMap[slo.sloId] = slo.text
    })

    const findProgram = (programId) => {
        if (programId) {
            let program = props.department.submittedPrograms.find((p) => p.programId == programId)
            return program.name
        }
        return 'Unrecognized Program with ID ' + programId
    }

    const findTheme = (themeId) => {
        if (themeId) {
            let theme = props.themes.find((t) => t.themeId == themeId)
            return theme.name
        }
        return 'Unrecognized Theme with ID ' + themeId
    }

    const sortOutcomes = (unsortedOutcomes) => {
        return unsortedOutcomes.sort((a,b) => a.sloId > b.sloId ? 1 : ((a.sloId < b.sloId) ? -1 : 0))
    }
    
    // Open all Accordion Items by default
    let phaseOneTabs=["1", "2", "3", "4", "5"]
    let phaseTwoTabs=["6", "7", "8"]

    let defaultTabs = []
    if (CURRENT_PHASE == PHASE_ONE) {
        defaultTabs = phaseOneTabs
    } else if (CURRENT_PHASE == PHASE_TWO) {
        defaultTabs = phaseTwoTabs
    }

    return (
        <div className="row row-cols-1 row-cols-md-1">
            <div className="p-5 text-center">
                <h3>View Assessment</h3>
            </div>

            <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>A. {SECTION_TITLE_1}</Accordion.Header>
                    <Accordion.Body>
                        <Table striped>
                            <tbody>
                                <tr>
                                    <td>Program</td>
                                    <td>{findProgram(assessment.programId)}</td>
                                </tr>
                                <tr>
                                    <td>Assessment Reporter</td>
                                    <td>{assessment.modifiedBy}</td>
                                </tr>
                                <tr>
                                    <td>Theme</td>
                                    <td>
                                        {findTheme(assessment.themeId)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Review Year</td>
                                    <td>
                                        {assessment.reviewYear}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Accordion.Body>
                </Accordion.Item>
                
                <Accordion.Item eventKey="2">
                    <Accordion.Header>B. {SECTION_TITLE_2}</Accordion.Header>
                    <Accordion.Body>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                    <th>Focus Area</th>
                                </tr>
                                
                            </thead>
                            <tbody>
                                {step1Data &&
                                    sortOutcomes(step1Data.learningOutcomes).map((lo, key) => {
                                        return (
                                        <tr key={key}>
                                            <td>{learningOutcomesMap[lo.sloId]}</td>
                                            <td>{lo.focusQuestion}</td>
                                        </tr>
                                        )
                                        
                                    })
                                }
                            </tbody>
                        </Table>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                    <Accordion.Header>C. {SECTION_TITLE_3}</Accordion.Header>
                    <Accordion.Body>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                    <th>Description of Assessment Tool</th>
                                    <th>Population or Courses Assessed</th>
                                    <th>Hypothetical Analysis/Target</th>
                                </tr>
                                
                            </thead>
                            <tbody>
                                { step2Data &&
                                    sortOutcomes(step2Data.learningOutcomes).map((lo, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{learningOutcomesMap[lo.sloId]}</td>
                                                <td>{lo.toolDescription}</td>
                                                <td>{lo.coursesAssessed}</td>
                                                <td>{lo.hypotheticalAnalysis}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                    <Accordion.Header>D. {SECTION_TITLE_4}</Accordion.Header>
                    <Accordion.Body>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                    <th>Summary of Results</th>
                                    <th>Reflection on Focus Area</th>
                                    <th>Interpretation of Results</th>
                                </tr>
                                
                            </thead>
                            <tbody>
                                { step4Data &&
                                    sortOutcomes(step4Data.learningOutcomes).map((lo, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{learningOutcomesMap[lo.sloId]}</td>
                                                <td>{lo.resultsSummary}</td>
                                                <td>{lo.focusAreaReflection}</td>
                                                <td>{lo.interpretationOfResults}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                    <Accordion.Header>E. {SECTION_TITLE_5}</Accordion.Header>
                    <Accordion.Body>
                        { step5Data && 
                            sortOutcomes(step5Data.learningOutcomes).map((lo, key) => {
                                return (
                                    <Table striped key={key}>
                                        <thead>
                                            <tr>
                                                <th colSpan="2" style={{'backgroundColor': '#dddddd'}}>
                                                    {learningOutcomesMap[lo.sloId]}
                                                </th>
                                            </tr>
                                        </thead>
                                    <tbody>
                                        <tr>
                                            <td>Describe the change that was implemented.</td>
                                            <td>{lo.changesPlanned}</td>
                                        </tr>
                                        <tr>
                                            <td>Type of Change</td>
                                            <td>
                                                <ChangeList slo={lo} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Change in Assessment Approach or Tools?</td>
                                            <td>{lo.changeInApproach}</td>
                                        </tr>
                                        <tr>
                                            <td>What data motivated the change?</td>
                                            <td>{lo.dataMotivation}</td>
                                        </tr>
                                        <tr>
                                            <td>Hypothesis about the effect the change will have?</td>
                                            <td>{lo.changeHypothesis}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                )
                            })
                        }
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                    <Accordion.Header>F. {SECTION_TITLE_6}</Accordion.Header>
                    <Accordion.Body>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                    <th>Description of Assessment Tool</th>
                                    <th>Population or Courses Assessed</th>
                                </tr>
                                
                            </thead>
                            <tbody>
                                { step5Data &&
                                    sortOutcomes(step5Data.learningOutcomes).map((lo, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{learningOutcomesMap[lo.sloId]}</td>
                                                <td>{lo.secondRoundToolDescription}</td>
                                                <td>{lo.secondRoundCoursesAssessed}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                    <Accordion.Header>G. {SECTION_TITLE_7}</Accordion.Header>
                    <Accordion.Body>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                    <th>Summary of Second<br/>Round Results</th>
                                    <th>Interpretation of Results, <br/>Pre- and Post-Change</th>
                                    <th>Follow up questions, <br/>possible next steps</th>
                                </tr>
                                
                            </thead>
                            <tbody>
                            { step7Data &&
                                    sortOutcomes(step7Data.learningOutcomes).map((lo, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{learningOutcomesMap[lo.sloId]}</td>
                                                <td>{lo.summaryOfResults}</td>
                                                <td>{lo.interpretationOfBothRounds}</td>
                                                <td>{lo.followUpAndNextSteps}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="8">
                    <Accordion.Header>H. {SECTION_TITLE_8}</Accordion.Header>
                    <Accordion.Body>
                        <Container>
                            <Row className="p-3">
                                <Col>
                                    Describe any change in student achievement observed as part of this assessment process,
                                    and what led to those changes.
                                    <br /><br />
                                    <div className="p-3 bg-light border">
                                        {step7Data?.finalReflection.studentAchievementChanges}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="p-3">
                                <Col>
                                    Describe long-term changes in the program(s) that the assessment process led to, and what
                                    motivated those changes?
                                    <br /><br />
                                    <div className="p-3 bg-light border">
                                        {step7Data?.finalReflection.longTermProgramChanges}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="p-3">
                                <Col>
                                    What did you learn about the teaching and learning of "Practicing Community" in your programs?
                                    <br /><br />
                                    <div className="p-3 bg-light border">
                                        {step7Data?.finalReflection.themeLessonsLearned}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="p-3">
                                <Col>
                                    Describe any external factors affecting the program or affecting assessment of the program.
                                    <br /><br />
                                    <div className="p-3 bg-light border">
                                        {step7Data?.finalReflection.externalFactors}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <div className="p-3 text-center">
                <LinkContainer to={'/assessment/edit/' + props.departmentAssessmentId}>
                    <Button 
                        href={'/assessment/edit/' + props.departmentAssessmentId}
                        variant="primary"
                        size="lg">
                        Modify
                    </Button>
                </LinkContainer>
                {' '}
                <LinkContainer to="/">
                    <Button 
                        href="/"
                        variant="outline-primary"
                        size="lg">
                        Back
                    </Button>
                </LinkContainer>
            </div>
        </div>
    )
}